<template>
  <div class="container-fluid">
    <skin-regimen-record
      v-if="isCreated"
      :general="generalConfig"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SkinRegimenRecord from '@/components/Print/SkinRegimenRecord.vue';

export default {
  name: 'SkinRegimen',
  components: {
    SkinRegimenRecord,
  },
  data() {
    return {
      isCreated: false,
      selectedInvoice: {},
    };
  },
  computed: {
    ...mapGetters('config', {
      generalConfig: 'general',
    }),
  },
  mounted() {
    setTimeout(() => {
      window.print();
    }, 2000);
  },
  async created() {
    this.isCreated = true;
  },
};
</script>
